<template>
  <div class="tile-container">
    <current-user-photo class="avatar" />
    <h3 class="name" @click="goTo('userInfo', user.id)">
      {{ user.firstName }} {{ user.lastName }}
    </h3>
    <h4 class="jobTitle">
      {{ user.jobTitle }}
    </h4>
    <div class="count-infos">
      <div class="count-item">
        <div class="number">
          <span>{{ stats.countPublishedPosts }}</span>
        </div>
        <span class="type">{{ $t('user.userInfoTile.posts') }}</span>
      </div>
      <div class="count-item">
        <div class="number">
          <span>{{ stats.countCreatedCommunities }}</span>
        </div>
        <span class="type">{{ $t('user.userInfoTile.createdCommunities') }}</span>
      </div>
      <div class="count-item">
        <div class="number">
          <span>{{ stats.countFollowedCommunities }}</span>
        </div>
        <span class="type">{{ $t('user.userInfoTile.followedCommunities') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import CurrentUserPhoto from '../shared/CurrentUserPhoto'

export default {
  name: 'UserInfoTile',
  components: { CurrentUserPhoto },
  props: {
    user: {
      type: Object,
      required: true
    },
    stats: {
      type: Object,
      required: true
    }
  },
  methods: {
    goTo(page, id) {
      this.$router.push({ name: page, params: { id: id } })
    }
  }
}
</script>

<style scoped lang="scss">

.tile-container {
  display: flex;
  flex-direction: column;
  margin: 1rem;

  .avatar {
    height: 100px;
  }

  .name {
    font-weight: 600;
    font-size: 18px;
    cursor: pointer;
    margin: 0;
  }

  .jobTitle {
    font-size: 16px;
    font-weight: normal;
    margin: 0;
  }

  .userPoints {
    margin-top: 1rem;
  }

  .count-infos {
    display: flex;
    flex-direction: column;
    font-size: 13px;
    margin: 2rem 0;

    .count-item {
      margin: 5px;
      display: flex;
      flex-grow: 1;
      flex-direction: row;
      width: 100%;
      overflow-x: hidden;
      align-items: center;

      .number {
        align-items: center;
        justify-content: center;
        display: flex;
        flex-direction: column;
        width: 46px;
        min-width: 46px;
        height: 46px;
        background-color: #d8d8d8;
        border-radius: 100%;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 4px;
      }

      .type {
        width: 100%;
        text-align: left;
        margin-left: 5px;
      }
    }
  }
}

</style>
